@if (fullDataTable && fullDataTable.length) {
  <div [ngClass]="(shareSvc.isMobileMode()) ? 'mobile':'desc'">
    <div [id]="gridId" class="table-wrap">
      <h5 class="table-title my-3" translate>{{title || attributes?.title}}</h5>
      @if (subTitle) {
        <p class="mb-3 sub-title">{{subTitle}}</p>
      }
      @if (filtersField && filtersField.length) {
        <div class="row">
          @for (filterValues of filtersField; track filterValues) {
            <div class="col-12">
              <div class="pb-4 pb-lg-3 pr-4 pr-lg-0 pt-3">
                @for (val of filterValues.value; track val) {
                  <mat-checkbox (change)="filterData(filterValues.key,val,filterValues.value)" class="example-margin pl-3 mb-2 mb-lg-0 pl-lg-4" [(ngModel)]="val['checked']">{{val['name']}}</mat-checkbox>
                }
              </div>
            </div>
          }
        </div>
      }
      <!--class="material expandable mb-2"-->
      <ngx-datatable
        [attr.role]="'table'"
        #gridTable
        [ngClass]="{'no-count': !count}"
        class="material striped"
        [rows]="dataTable"
        [columnMode]="'force'"
        [rowHeight]="'auto'"
        [headerHeight]="50"
        [footerHeight]="footerHeight"
        [loadingIndicator]="dtLineTable.loading"
        [rowClass]="getRowClass"
        [externalPaging]="externalPaging"
        [count]="page.totalElements"
        [offset]="page.pageNumber"
        [limit]="page.size"
        [messages]="{emptyMessage: 'No data to display' | translate, totalMessage: 'Total' | translate, selectedMessage: false}"
        (page)="getData($event)"
        >
        <!-- Row Detail Template -->
        <ngx-datatable-row-detail  [rowHeight]="100" #myDetailRow  [ngClass]="{'d-none': !shareSvc.isMobileMode()}">
          <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
            @for (column of columns | slice:count:columns.length; track column; let index = $index) {
              <div class="row py-3" >
                <div class="col-4">
                  <strong>{{(dataTableConfig[column.name].alias || column.name) | translate}}</strong>
                </div>
                @if (dataTableConfig[column.name].booleanValue && dataTableConfig[column.name].booleanValue == true) {
                  <div class="col-8 text-truncate"
                    [ngClass]="{'not-checked':row[column.name] == '0' ,'checked':row[column.name] == '1','has-tooltip': dataTableConfig[column.name].tooltip && row[dataTableConfig[column.name].tooltip]}"
                    attr.aria-label="{{column.name +row[column.name]=='1'?'yes':'no' | translate}}">
                    @if (row[column.name] == '1') {
                      <i  role="label" class="fa fa-check" aria-hidden="true"></i>
                    }
                    @if (row[column.name] == '0') {
                      <i  class="fa fa-times" aria-hidden="true"></i>
                    }
                  </div>
                } @else {
                  <div class="col-8 text-truncate {{dataTableConfig[column.name].style}}"
                                     [ngClass]="{'break-line': dataTableConfig[column.name].breakLength,
                                      'has-tooltip': dataTableConfig[column.name].tooltip && row[dataTableConfig[column.name].tooltip],
                                       'd-flex': readMoreType =='icon',
                                       'expanded': row['showAllText'+index]}" translate>
                    <span [ngClass]="{'ellipsis': !row['showAllText'+index] && line}" [innerHTML]="getFieldData(row, dataTableConfig[column.name], dataTableConfig[column.name].breakLength, index) | safe: 'html'"></span>
                    @if (line || ((!shareSvc.isMobileMode())? (row[column.name]?row[column.name + '_char'].length:0)>dataTableConfig[column.name].breakLength:(breakLength && (row[column.name]?row[column.name + '_char'].length:0)>breakLength))) {
                      <button class="btn btn-link p-0 break-length-btn"
                        [ngClass]="{'mt-auto': line}"
                        (click)="toggleOpen($event, row, index)">
                        @if (!row['showAllText'+index] && readMoreType =='text') {
                          <span translate>read more</span>
                        }
                        @if (row['showAllText'+index] && readMoreType =='text') {
                          <span translate>close</span>
                        }
                        @if (!row['showAllText'+index] && readMoreType =='icon' ) {
                          <span translate><i class="fa fa-solid fa-angle-down"></i></span>
                        }
                        @if (row['showAllText'+index] && readMoreType =='icon') {
                          <span translate><i class="fa fa-solid fa-angle-up"></i></span>
                        }
                      </button>
                    }
                  </div>
                }
              </div>
            }
          </ng-template>
        </ngx-datatable-row-detail>
        @for (column of columns | slice:0:count; track column; let index = $index) {
          <ngx-datatable-column role="cell" [width]="dataTableConfig[column.name].width?dataTableConfig[column.name].width:100"
            name={{column.name}}
            [cellClass]="dataTableConfig[column.name].style"
            [headerClass]="dataTableConfig[column.name].style">
            <ng-template let-column="column" ngx-datatable-header-template translate>
              <span role="presentation" >{{( dataTableConfig[column.name].alias || column.name ) | translate}}</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template role="row">
              <div class="text-truncate d-inline-block" role="cell"
                [tooltip]="dataTableConfig[column.name].tooltip && row[dataTableConfig[column.name].tooltip] ? tooltipTemplate : null"
                #gridToolTip="bs-tooltip"
                on-mouseover="setTooltipData(row[dataTableConfig[column.name].tooltip])"
                [tooltipPlacement]="'top'"
                [tooltipTrigger]="'hover:focus'"
                [tooltipClass]="key+'-tooltip'"
                [tooltipAppendToBody]="false"
                >
                @if (dataTableConfig[column.name].booleanValue && dataTableConfig[column.name].booleanValue == true) {
                  <div class="col-6 text-truncate d-inline-block"
                    [ngClass]="{'not-checked':row[column.name] == '0' ,'checked':row[column.name] == '1','has-tooltip': dataTableConfig[column.name].tooltip && row[dataTableConfig[column.name].tooltip]}"
                    >
                    @if (row[column.name] == '1') {
                      <i attr.aria-label="{{column.name +'yes' | translate}}" class="fa fa-check" ></i>
                    }
                    @if (row[column.name] == '0') {
                      <i attr.aria-label="{{column.name +'no' | translate}}" class="fa fa-times" ></i>
                    }
                  </div>
                } @else {
                  <div class="text-truncate {{ readMoreType =='icon' ? 'd-flex' : 'd-inline-block' }}"
                                 [ngClass]="{'break-line': dataTableConfig[column.name].breakLength,
                                  'has-tooltip': dataTableConfig[column.name].tooltip && row[dataTableConfig[column.name].tooltip],
                                  'expanded': row['showAllText'+index]}" translate>
                    <span [ngClass]="{'ellipsis': !row['showAllText'+index] && line}" [innerHTML]="getFieldData(row, dataTableConfig[column.name], dataTableConfig[column.name].breakLength, index) | safe: 'html'"></span>
                    @if (line || ((!shareSvc.isMobileMode())? (row[column.name]?row[column.name + '_char'].length:0)>dataTableConfig[column.name].breakLength:(breakLength && (row[column.name]?row[column.name + '_char'].length:0)>breakLength))) {
                      <button  class="btn btn-link p-0 break-length-btn"
                        [ngClass]="{'mt-auto': line}"
                        (click)="toggleOpen($event, row, index)">
                        <!--                                         (click)="row['showAllText'+index]=!row['showAllText'+index]">-->
                        @if (!row['showAllText'+index] && readMoreType =='text') {
                          <span translate>read more</span>
                        }
                        @if (row['showAllText'+index] && readMoreType =='text') {
                          <span translate>close</span>
                        }
                        @if (!row['showAllText'+index] && readMoreType =='icon' ) {
                          <span translate><i class="fa fa-solid fa-angle-down"></i></span>
                        }
                        @if (row['showAllText'+index] && readMoreType =='icon') {
                          <span translate><i class="fa fa-solid fa-angle-up"></i></span>
                        }
                      </button>
                    }
                  </div>
                }
              </div>
            </ng-template>
          </ngx-datatable-column>
        }
        @if (count && shareSvc.isMobileMode()) {
          <ngx-datatable-column
            [width]="50"
            [resizeable]="false"
            [sortable]="false"
            [draggable]="false"
            [canAutoResize]="false"
            >
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
              <a
                class="expanded-icon"
                href="javascript:void(0)"
                title="Expand/Collapse Row"
                (click)="toggleExpandRow($event, row)"
                >
                <i [ngClass]="{'fa-times': expanded,'fa-angle-left': !expanded}" class="fa" aria-hidden="true"></i>
              </a>
            </ng-template>
          </ngx-datatable-column>
        }
      </ngx-datatable>
    </div>
  </div>
}

<ng-template #tooltipTemplate>
  <div [innerHtml]="tooltipData"></div>
</ng-template>
